import React from 'react'

import { Card } from './Card'

interface Props { }

interface State { }

export class ContactForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
  }

  public render() {
    return (
      <Card title="ご相談はこちら">
        <p>このレポートについてもっと詳しく聞きたい、具体的な手法を知りたい方は個別にご相談ください。</p>
        <iframe src="//www.ideamans.com/_mautic/form/38" width="640" height="500" style={{ border: 'none' }}><p>Your browser does not support iframes.</p></iframe>
      </Card >
    )
  }
}